module.exports = __webpack_public_path__ + "img/pin-5000.84420661.png";